<button
  mat-stroked-button
  [matMenuTriggerFor]="shopper ? shopperSendMenu : (eligibleInvoices.length === 1 ? invoiceSendMenu : invoiceListMenu)"
  [matMenuTriggerData]="shopper ? null : (eligibleInvoices.length === 1 ? { invoice: eligibleInvoices[0] } : null)"
  [disabled]="(shopper ? false : eligibleInvoices.length === 0) || (loading$ | async)"
>
  <mat-icon>send</mat-icon>
  <span>{{ 'common.send' | translate }}</span>
</button>

<mat-menu #invoiceListMenu="matMenu">
  <ng-container *ngFor="let inv of eligibleInvoices">
    <button
      mat-menu-item
      [matMenuTriggerFor]="invoiceSendMenu"
      [matMenuTriggerData]="{ invoice: inv }"
    >
      <mat-icon>description</mat-icon>
      <span>{{ inv.shortId | shortId }}</span>
    </button>
  </ng-container>
</mat-menu>

<mat-menu #invoiceSendMenu="matMenu">
  <ng-template matMenuContent let-invoice="invoice">
    <button
      mat-menu-item
      [disabled]="!canSendEmail(invoice)"
      (click)="openSendDialog(invoice, 'link', 'email')"
    >
      <mat-icon>send</mat-icon>
      {{ 'invoice-card.button-send-link' | translate }}
    </button>
    <button
      mat-menu-item
      [disabled]="!canSendSms(invoice)"
      (click)="openSendDialog(invoice, 'link', 'sms')"
    >
      <mat-icon>send</mat-icon>
      {{ 'invoice-card.button-send-sms' | translate }}
    </button>
    <mat-divider></mat-divider>
    <button
      mat-menu-item
      [disabled]="!canSendEmail(invoice)"
      (click)="openSendDialog(invoice, 'pdf')"
      matTooltip="Sends the invoice as a PDF to the patient"
    >
      <mat-icon>send</mat-icon>
      {{ 'shopper-estimates-dashboard.messages.send-document' | translate }}
    </button>
  </ng-template>
</mat-menu>

<mat-menu #shopperSendMenu="matMenu">
  <button
    mat-menu-item
    [disabled]="!canShopperSendEmail()"
    (click)="openShopperSendDialog('email')"
  >
    <mat-icon>send</mat-icon>
    {{ 'invoice-card.button-send-link' | translate }}
  </button>
  <button
    mat-menu-item
    [disabled]="!canShopperSendSms()"
    (click)="openShopperSendDialog('sms')"
  >
    <mat-icon>send</mat-icon>
    {{ 'invoice-card.button-send-sms' | translate }}
  </button>
  <mat-divider></mat-divider>
  <button
    mat-menu-item
    [disabled]="!canShopperSendEmail()"
    (click)="openShopperSendDialog('email', 'pdf')"
    matTooltip="Sends the estimate as a PDF to the patient"
  >
    <mat-icon>send</mat-icon>
    {{ 'shopper-estimates-dashboard.messages.send-document' | translate }}
  </button>
</mat-menu>
